const routes = {
  offer: "offer-promo-code",
  assetCollection: "asset-collection",
  espIntegration: "email-service-provider-integration",
};

export default routes;
